import { Extension } from "@tiptap/core";
import axios from "axios";
const OPEN_AI_KEY = process.env.REACT_APP_OPEN_AI_KEY;

const AITextGeneration = Extension.create({
  name: "aiTextGeneration",

  addCommands() {
    return {
      generateAIContent:
        (prompt) =>
        async ({ editor }) => {
          try {
            // Call AI API (e.g., OpenAI's GPT)
            console.log(prompt);

            const response = await axios.post(
              "https://api.openai.com/v1/chat/completions",
              {
                model: "gpt-3.5-turbo-0125", // Use appropriate model
                // prompt: prompt,
                max_tokens: 200,
                temperature: 0.7,
                messages: [
                  {
                    role: "system",
                    content: `You are an assistant in a text editor. The current content is: ${prompt}`,
                  },
                  {
                    role: "user",
                    content: prompt,
                  },
                ],
              },
              {
                headers: {
                  Authorization: `Bearer ${OPEN_AI_KEY}`
                },
              }
            );
            console.log(response);
            // Get AI generated content
            const generatedContent = response.data.choices[0]?.message?.content;
            console.log(generatedContent, response)
            // Insert the generated content into the editor
            editor.commands.insertContent(generatedContent);
          } catch (error) {
            editor.commands.insertContent("Error");
            console.error("Error generating AI content:", error);
          }
        },
    };
  },
});

export default AITextGeneration;
